import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const SessionExpiredModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onOk={onClose}
      onCancel={onClose}
      centered
      closable={false}
      okText={t('modals.sessionExpired.ok')}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{
        style: {
          backgroundColor: 'rgb(250, 215, 50)',
          color: '#000',
          borderColor: 'rgb(250, 215, 50)',
          width: '200px',
          height: '48px',
          fontSize: '16px',
          fontWeight: '500',
          borderRadius: '9999px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
        }
      }}
      bodyStyle={{
        padding: '32px',
        textAlign: 'center'
      }}
      width={500} 
    >
      <h3 style={{ marginBottom: '16px' }}>{t('modals.sessionExpired.title')}</h3>
      <p>{t('modals.sessionExpired.text')}</p>
    </Modal>
  );
};

export default SessionExpiredModal;
